import type { Option } from "@typings/product/item";

export const optionsToVariantName = (
  options: Option[],
  selected: { [optionId: number]: number }
) => {
  let name = "";
  let isFirstOption = true;

  for (const [optionId, optionValueId] of Object.entries(selected)) {
    const option = options.find((o) => o.id === +optionId)!;
    const optionValue = option.values.find((v) => v.id === optionValueId)!;

    name += isFirstOption ? optionValue.name : ` / ${optionValue.name}`;
    isFirstOption = false;
  }

  return name;
};
